import React, { Component } from 'react'
import { EmployerContactUs } from '../../action/loiAction';
import { onChange } from '../../utils';
import swal from 'sweetalert';
export default class extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: { name: 'name', value: '', error: '', isRequired: true },
            email: { name: 'email', value: '', error: '', isRequired: true },
            mobile: { name: 'mobile', value: '', error: '', isRequired: true },
            message: { name: 'message', value: '', error: '', isRequired: true },
        }
    }

    handleChange = (e) => {
        e.preventDefault()
        let name = e.target.name
        let value = e.target.value
        onChange(this, name, value, () => {
            console.log(e);
        })
    }

    validateEnquiryForm = () => {
        let data = this.state
        let error = {}
        let isValid = true

        if (!data['name'].value) {
            let name = data['name']
            name.error = "Please Enter Name"
            isValid = false
            this.setState({
                name: name
            })
        }

        if (!data['email'].value) {
            let email = data['email']
            email.error = "Please Enter Email"
            isValid = false
            this.setState({
                email: email
            })
        }

        if (data['email'].value) {
            let re = /\S+@\S+\.\S+/
            if (re.test(data['email'].value)) { } else {
                let email = data['email']
                email.error = "Please Enter Valid Email"
                isValid = false
                this.setState({
                    email: email
                })
            }
        }
        if (!data['mobile'].value) {
            let mobile = data['mobile']
            mobile.error = "Please Enter Mobile"
            isValid = false
            this.setState({
                mobile: mobile
            })
        }

        if (data["mobile"] != "") {
            const regexExp = /^[6789][0-9]{9}/
            if (regexExp.test(data.mobile.value)) { } else {
                let mobile = data['mobile']
                mobile.error = "Please Enter Valid Mobile Number";
                isValid = false;
            }
        }

        if (!data['message'].value) {
            let message = data['message']
            message.error = "Please Enter Your Message"
            isValid = false
        }

        this.setState({
            error: error
        })

        return isValid
    }

    onSubmit(e) {
        e.preventDefault();
        const { name, email, mobile, message } = this.state

        const model = {
            NAME: name.value,
            EMAIL: email.value,
            MOBILE: mobile.value,
            Message: message.value
        }
        if (this.validateEnquiryForm()) {
            EmployerContactUs(model).then((res) => {
                debugger
                if (res.status) {
                    debugger
                    swal({
                        icon: "success",
                          text: "Our Team Will Contact You Soon",
                        timer: 2000,
                        showCancelButton: false,
                        showConfirmButton: false,
                    });
                    window.location.reload()

                }
                else {
                    alert(res.error)
                }

            }).catch(err => {
                alert(err)
            })
        }
    }


    render() {
        const { name, email, mobile, message } = this.state
        return (
            <React.Fragment>
                <section className="pricing-area padding-top-100px padding-bottom-80px">
                    <div className='container'>
                        <div className="row">
                            <div className='col-lg-6 mx-auto text-center'>
                                <img style={{ width: "70%", height: "80%" }} src={'./assets/images/contact-us.png'} />
                            </div>
                            <div className="col-md-6">
                                <div className='rec-contact-form'>
                                    <h5>Contact Us</h5>
                                    <form action="">
                                        <div className="form-group">
                                            <input type="text"
                                                name={name.name}
                                                value={name.value}
                                                onChange={(e) => this.handleChange(e)}
                                                className='form-control'
                                                placeholder='Enter Name' />
                                            {name.error.length > 0 && !name.value && <span className='text-danger ml-1'>{name.error}</span>}

                                        </div>
                                        <div className='form-group'>
                                            <input type="text"
                                                name={email.name}
                                                value={email.value}
                                                onChange={(e) => this.handleChange(e)}
                                                className='form-control'
                                                placeholder='Enter Email' />
                                            {email.error.length > 0 && !email.value && <span className='text-danger ml-1'>{email.error}</span>}

                                        </div>
                                        <div className='form-group'>
                                            <input type="text"
                                                name={mobile.name}
                                                value={mobile.value}
                                                maxLength={10}
                                                onChange={this.handleChange}
                                                className='form-control'
                                                placeholder='Enter Mobile Number' />
                                            {mobile.error.length > 0 && !mobile.value && <span className='text-danger ml-1'>{mobile.error}</span>}

                                        </div>
                                        <div className='form-group'>
                                            <textarea type="text"
                                                name={message.name}
                                                value={message.value}
                                                onChange={(e) => this.handleChange(e)}
                                                className='form-control'
                                                placeholder='Enter Message Here' />
                                            {message.error.length > 0 && !message.value && <span className='text-danger ml-1'>{message.error}</span>}
                                        </div>
                                        <button className='btn btn-danger px-4 mt-3' onClick={(e) => { this.onSubmit(e) }}>Submit</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </React.Fragment>
        )
    }
}
